module.exports = __webpack_public_path__ + "img/Recubre_Repello Lanzable Gris.e510cbe3.png";